import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import { Select } from '@material-ui/core';

type FrameType = {
  [key: string]: number;
};

export const FrameTypeEnum: FrameType = {
  PLASTIC_FULL_FRAME: 1,
  METAL_FULL_FRAME: 2,
  NYLOR: 3,
  METAL_GROOVE: 4,
  RIMLESS: 5,
};

interface Props {
  frameType: number | undefined,
  onChange: (frameType: number) => void,
}

export default ((props) => {
  let selectedFrameType = props.frameType !== undefined ? props.frameType : -1;

  useEffect(() => {
    if (props.frameType === undefined) {
      props.onChange(selectedFrameType);
    }
  }, [props, selectedFrameType]);

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    props.onChange(Number(event.target.value));
  };

  const frameTypes = Object.values(FrameTypeEnum);

  return (
    <Select value={selectedFrameType} onChange={handleSelectChange}>
      <MenuItem key={-1} value={-1}>--</MenuItem>
      {frameTypes.map((frameType) => (
        <MenuItem key={frameType} value={frameType}>{Object.keys(FrameTypeEnum).find(key => FrameTypeEnum[key] === frameType)}</MenuItem>
      ))}
    </Select>
  );
}) as React.FC<Props>;